'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _every = require('lodash/every');

var _every2 = _interopRequireDefault(_every);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _baseState = require('./baseState');

var _baseState2 = _interopRequireDefault(_baseState);

var _webApiClientSingleton = require('../webApiClientSingleton');

var _webApiClientSingleton2 = _interopRequireDefault(_webApiClientSingleton);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _streamMapper = require('../streamMapper');

var _streamMapper2 = _interopRequireDefault(_streamMapper);

var _nowPlayingPoller = require('../nowPlayingPoller');

var _nowPlayingPoller2 = _interopRequireDefault(_nowPlayingPoller);

var _getAdswizzListenerId = require('../utils/getAdswizzListenerId');

var _getAdswizzListenerId2 = _interopRequireDefault(_getAdswizzListenerId);

var _cancelable = require('../utils/cancelable');

var _cancelable2 = _interopRequireDefault(_cancelable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlStreamFormat = 'html';
var programPrefix = 'p';
var guideId = void 0;
var cancelableTunePromise = void 0;
var loadingPromise = void 0;

function onFail(error) {
  loadingPromise.reject(error);
  _tuner2.default.changeState(_tuner2.default.states.failed, error);
}

function filterStreams(streams, formats) {
  if (formats) {
    return (0, _filter2.default)(streams, function (stream) {
      return (0, _includes2.default)(formats, stream.format);
    });
  }

  return streams;
}

function handleStreams(streams, singleTestStream) {
  var loadingMetadata = {};

  if (singleTestStream) {
    _tuner2.default.streams = streams;
    _tuner2.default.changeState(_tuner2.default.states.loaded);
  } else {
    var mappedStreams = _streamMapper2.default.fromTuneResponse(streams);
    var filteredStreams = filterStreams(mappedStreams, _tuner2.default.tune.formats);
    if (filteredStreams.length && (0, _every2.default)(filteredStreams, function (stream) {
      return stream.format === htmlStreamFormat;
    })) {
      // first stream is used because there is currently
      // no support for selection of multiple HTML streams.
      // better approach would be to trigger this event with all streams
      // and let the callee decide what to do with them.
      _tuner2.default.trigger(_tuner2.default.events.htmlStreamLoaded, filteredStreams[0].url);

      loadingMetadata.isHtmlStream = true;
    } else if (filteredStreams.length) {
      // exclude html streams as they cannot be played by our streamPlayer
      _tuner2.default.streams = (0, _filter2.default)(filteredStreams, function (stream) {
        return stream.format !== htmlStreamFormat;
      });
      _tuner2.default.changeState(_tuner2.default.states.loaded);
    } else {
      var error = new Error('no formats');
      error.errorData = { guideId: guideId };
      onFail(error);

      // don't resolve loading promise on fail
      return;
    }

    loadingPromise.resolve(loadingMetadata);
  }
}

function onTuneSuccess(tuneResponse) {
  var head = tuneResponse.data.head;

  if (head.status !== '200') {
    var error = new Error('tune.ashx response error');
    error.errorData = tuneResponse;
    onFail(error);
    return;
  }

  var streams = tuneResponse.data.body;

  if ((0, _isEmpty2.default)(streams)) {
    var _error = new Error('no tunable streams');
    _error.errorData = { guideId: guideId };
    onFail(_error);
  } else {
    handleStreams(streams, false);
  }
}

function onNowPlayingChanged(data) {
  _tuner2.default.trigger(_tuner2.default.events.nowPlayingChanged, data);
}

function tune(promise) {
  var _get = (0, _get3.default)(_tuner2.default, 'tune', {}),
      itemToken = _get.itemToken,
      formats = _get.formats,
      type = _get.type,
      testStreamId = _get.testStreamId,
      testStreamUrl = _get.testStreamUrl,
      testStreamFormat = _get.testStreamFormat,
      tuneGuideId = _get.guideId,
      isUserSubscribed = _get.isUserSubscribed,
      hasMetPrerollQuota = _get.hasMetPrerollQuota,
      _get$params = _get.params,
      params = _get$params === undefined ? {} : _get$params;

  guideId = testStreamId || tuneGuideId;
  loadingPromise = promise;

  if (testStreamUrl) {
    /*
      the handleStreams block is normally executed on a
      successful tune call. This bypasses that with a
      test stream url.
    */
    handleStreams([{
      url: testStreamUrl,
      requiresUnwrap: false,
      isFinalStream: true,
      format: testStreamFormat || 'mp3',
      position: 0
    }], {}, true); // pass true to indicate that this is a single test stream
  } else {
    var audience = params.audience,
        ccpaStatus = params.ccpaStatus,
        palNonce = params.palNonce,
        gdprTcString = params.gdprTcString,
        gdprApplies = params.gdprApplies;

    var loadOptions = {
      audience: audience,
      id: guideId,
      render: 'json',
      listenId: _tuner2.default.listenId,
      itemToken: itemToken,
      formats: formats,
      type: type,
      us_privacy: ccpaStatus
    };

    if (palNonce) {
      loadOptions.paln = palNonce;
    }

    // gdprApplies is undefined until OneTrust determines whether GDPR applies
    // IMPORTANT: GDPR ATTRIBUTE MUST BE STRING
    if ((0, _isBoolean2.default)(gdprApplies)) {
      loadOptions.gdpr = gdprApplies ? '1' : '0';
    }

    if (gdprTcString) {
      loadOptions.gdpr_consent = gdprTcString;
    }

    var adswizzListenerId = (0, _getAdswizzListenerId2.default)();
    if (adswizzListenerId) {
      loadOptions.adswizzListenerId = adswizzListenerId;
    }

    var tunePromise = _webApiClientSingleton2.default.instance.tune.load(loadOptions);
    cancelableTunePromise = (0, _cancelable2.default)(tunePromise);

    var nowPlayingAndTune = function nowPlayingAndTune(nowPlayingGuideId) {
      var allPromises = [cancelableTunePromise];
      var nowPlayingPromise = _nowPlayingPoller2.default.fetchOnce(nowPlayingGuideId, onNowPlayingChanged);

      if (!isUserSubscribed && !hasMetPrerollQuota) {
        // the Now Playing response has ad-eligiblity metadata that we need for free users,
        // so we'll wait for that to resolve, too, so that we have it ready for preroll requests.
        allPromises.push(nowPlayingPromise);
      }

      _promise2.default.all(allPromises).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
            tuneResponse = _ref2[0];

        return onTuneSuccess(tuneResponse);
      }).catch(onFail);
    };

    if (guideId[0] === programPrefix) {
      var profilesPromise = _webApiClientSingleton2.default.instance.profile.getV3(guideId);
      profilesPromise.then(function (profiles) {
        // if it's a program, get the nowPlaying from the profiles call for the playing station
        var profileGuideId = (0, _get3.default)(profiles, 'data.items[0].children[0].guideId', guideId);
        nowPlayingAndTune(profileGuideId);
      });
    } else {
      nowPlayingAndTune(guideId);
    }
  }
}

function cancelCurrentPromises() {
  if (cancelableTunePromise) cancelableTunePromise.cancel();
  if (loadingPromise) loadingPromise.promise.cancel();
}

var state = {
  name: 'loading',
  enter: function enter(previousState, context) {
    _tuner2.default.trigger(_tuner2.default.events.loading);
    tune(context);
  },
  exit: function exit() {
    cancelCurrentPromises();
  },
  load: function load(promise) {
    cancelCurrentPromises();
    tune(promise);
  }
};

module.exports = (0, _extends3.default)({}, _baseState2.default, state);
//# sourceMappingURL=loading.js.map